import Main from "./main/Main";
import AuthenticationContextProvider from "./contexts/AuthContext";
import ThemeProvider from "./theme";
import SubscribersContextProvider from "./contexts/SubscribersContext";
import AdminsContextProvider from "./contexts/AdminsContext";
import ContactsContextProvider from "./contexts/ContactsContext";
import SocialIconContextProvider from "./contexts/SocialIconsContext";
import TeamContextProvider from "./contexts/TeamsContext";
import ProjectContextProvider from "./contexts/ProjectContext";

export default function App() {

  return (
    <ThemeProvider>
      <AuthenticationContextProvider>
        <SubscribersContextProvider>
          <AdminsContextProvider>
            <ContactsContextProvider>
              <SocialIconContextProvider>
                <TeamContextProvider>
                  <ProjectContextProvider>
                    {" "}
                    <Main />
                  </ProjectContextProvider>
                </TeamContextProvider>
              </SocialIconContextProvider>
            </ContactsContextProvider>
          </AdminsContextProvider>
        </SubscribersContextProvider>
      </AuthenticationContextProvider>
    </ThemeProvider>
  );
}

